import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const Image = createIcon({
  displayName: 'Image',
  viewBox: '0 0 32 32',
  path: [
    <svg fill="currentColor" key="image">
      <path
        clipRule="evenodd"
        d="M3.9998 6.39995H27.9998V25.6H3.99981L3.9998 6.39995ZM0.799805 6.39995C0.799805 4.63264 2.23249 3.19995 3.9998 3.19995H27.9998C29.7671 3.19995 31.1998 4.63264 31.1998 6.39995V25.6C31.1998 27.3673 29.7671 28.8 27.9998 28.8H3.99981C2.23249 28.8 0.799805 27.3673 0.799805 25.6V6.39995ZM7.22887 20.3561L12.035 13.1469C12.3757 12.6358 13.1415 12.6835 13.4162 13.2329L14.3997 15.1999L17.6905 10.5928C18.0254 10.124 18.7311 10.1521 19.0275 10.6462L24.8727 20.3883C25.1927 20.9215 24.8086 21.5999 24.1867 21.5999H7.89451C7.25555 21.5999 6.87444 20.8878 7.22887 20.3561Z"
        fillRule="evenodd"
      />
    </svg>,
  ],
})
